import React from 'react';

/**
 * 툴바용 공통 버튼 컴포넌트
 * 모든 툴바 버튼의 크기와 스타일을 통일
 * @param {Object} props
 * @param {React.ReactNode} props.children - 버튼 내용 (아이콘 + 텍스트)
 * @param {function} props.onClick - 클릭 핸들러
 * @param {boolean} props.disabled - 비활성화 상태
 * @param {string} props.title - 툴팁 텍스트
 * @param {string} props.variant - 버튼 스타일 ('default', 'danger', 'muted', 'ghost')
 * @param {string} props.className - 추가 CSS 클래스
 * @param {boolean} props.isActive - 활성 상태 (편집 중 등)
 * @param {string} props.dataTour - 온보딩 투어용 데이터 속성
 */
const ToolbarButton = ({
  children,
  onClick,
  disabled = false,
  title = '',
  variant = 'default',
  className = '',
  isActive = false,
  dataTour,
  ...props
}) => {
  // 기본 스타일: 모든 버튼이 동일한 높이와 패딩을 가짐 (50px 높이로 설정)
  const baseClasses = 'inline-flex items-center justify-center gap-2 px-4 py-3 text-sm font-medium rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-latte-500 focus:ring-offset-2 disabled:cursor-not-allowed h-[50px] min-h-[50px] whitespace-nowrap';
  
  // 변형별 스타일
  const variantClasses = {
    default: disabled
      ? 'bg-gray-300 text-gray-500 border border-gray-300'
      : isActive
      ? 'bg-gray-300 text-gray-500 border border-gray-300 cursor-default'
      : 'bg-gradient-to-r from-slate-50 to-gray-50 border border-slate-200 text-slate-700 hover:from-slate-100 hover:to-gray-100 hover:border-slate-300',
    
    danger: disabled
      ? 'bg-gray-300 text-gray-500 border border-gray-300'
      : 'text-gray-400 hover:text-red-600 hover:bg-red-50 border border-transparent hover:border-red-200',
    
    muted: disabled
      ? 'bg-gray-300 text-gray-500 border border-gray-300'
      : 'bg-gradient-to-r from-slate-50 to-gray-50 border border-slate-200 text-slate-700 hover:from-slate-100 hover:to-gray-100 hover:border-slate-300',
    
    ghost: disabled
      ? 'text-gray-300 hover:text-gray-300'
      : 'text-gray-500 hover:bg-gray-100 border border-transparent hover:border-gray-200'
  };

  const buttonClasses = `${baseClasses} ${variantClasses[variant]} ${className}`;

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      title={title}
      className={buttonClasses}
      data-tour={dataTour}
      {...props}
    >
      {children}
    </button>
  );
};

export default ToolbarButton;
